/* DYO theme — full-screen search overlay, progressive enhancement over /search. */
(function () {
  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;

  var input = overlay.querySelector('[data-search-input]');
  var resultsEl = overlay.querySelector('[data-search-results]');
  var form = overlay.querySelector('[data-search-form]');
  var toggles = document.querySelectorAll('[data-search-toggle]');
  var lastFocused = null;
  var debounceTimer = null;
  var latestTerm = '';

  function openOverlay() {
    lastFocused = document.activeElement;
    overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    window.setTimeout(function () { input.focus(); }, 150);
  }

  function closeOverlay() {
    overlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (lastFocused) lastFocused.focus();
  }

  toggles.forEach(function (t) {
    t.addEventListener('click', function () {
      if (overlay.getAttribute('data-open') === 'true') { closeOverlay(); } else { openOverlay(); }
    });
  });

  overlay.querySelectorAll('[data-search-close]').forEach(function (b) {
    b.addEventListener('click', closeOverlay);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.getAttribute('data-open') === 'true') closeOverlay();
  });

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(amount) {
    var num = parseFloat(amount) || 0;
    return 'Rs.' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function productListItemHtml(product) {
    var price = parseFloat(product.price_min);
    var comparePrice = parseFloat(product.compare_at_price_min);
    var onSale = comparePrice > price;
    var priceHtml = '<span class="price__now">' + formatMoney(price) + '</span>';
    if (onSale) priceHtml += '<s class="price__was">' + formatMoney(comparePrice) + '</s>';
    var badgeHtml = '';
    if (onSale) {
      var off = Math.round(((comparePrice - price) / comparePrice) * 100);
      badgeHtml = '<span class="tag tag-accent media__badge">-' + off + '%</span>';
    } else if (!product.available) {
      badgeHtml = '<span class="tag tag-neutral media__badge">Sold out</span>';
    }
    var imageHtml = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
      : '';
    return '' +
      '<a href="' + escapeHtml(product.url) + '" class="search-result">' +
        '<span class="search-result__media media media--square">' + imageHtml + badgeHtml + '</span>' +
        '<span class="search-result__body">' +
          '<span class="search-result__title">' + escapeHtml(product.title) + '</span>' +
          '<span class="price">' + priceHtml + '</span>' +
        '</span>' +
      '</a>';
  }

  function renderResults(products, term) {
    if (!products.length) {
      resultsEl.innerHTML = '<p class="search-overlay__empty">No products found for &ldquo;' + escapeHtml(term) + '&rdquo;.</p>';
      return;
    }
    var viewAllUrl = form.getAttribute('action') + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
    resultsEl.innerHTML = '' +
      '<div class="search-overlay__list">' + products.map(productListItemHtml).join('') + '</div>' +
      '<a class="search-overlay__viewall btn btn-secondary" href="' + viewAllUrl + '">' +
        'View all results for &ldquo;' + escapeHtml(term) + '&rdquo;' +
      '</a>';
  }

  function runSearch(term) {
    if (!term) {
      resultsEl.innerHTML = '';
      return;
    }
    resultsEl.innerHTML = '<div class="search-overlay__loading"><span class="spinner"></span></div>';
    // Uses the raw ".json" suggest endpoint and renders cards client-side:
    // the HTML section-render endpoint (section_id=predictive-search)
    // reliably comes back with zero products on this store even when
    // matches exist, while the .json endpoint returns correct results for
    // the same query — so results are built here instead of relying on it.
    var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=8' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,vendor';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (term !== latestTerm) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, term);
      })
      .catch(function () {
        if (term === latestTerm) resultsEl.innerHTML = '';
      });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    latestTerm = term;
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function () { runSearch(term); }, 300);
  });

  form.addEventListener('submit', function (e) {
    if (!input.value.trim()) e.preventDefault();
  });
})();
